import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { PreferencesApi } from '../_api/preferences.api';

@Injectable()
export class PreferencesService {
  constructor(private api: PreferencesApi) {}
}
